import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const HelmetMetaData = (props) => {
  const [seo, setSeo] = useState([]);
  const [general, setGeneral] = useState([]);

  useEffect(() => {
    axios.get("api/get_seo_data").then((res) => {
      if (res.data.status == "success") {
        // console.log(res.data.data);
        setSeo(res.data.data["seo"]);
        setGeneral(res.data.data["general"]);
      }
    });
  }, []);

  let db_seo_name = seo.seo_metakeyword !== null ? seo.seo_metakeyword : "";
  let db_seo_description =
    seo.seo_metadescription !== null ? seo.seo_metadescription : "";

  let location = useLocation();
  let currentUrl = general.host_name + location.pathname;
  let quote = props.quote !== undefined ? props.quote : "";
  // let title =
  //   props.title !== undefined
  //     ? props.title
  //     : "Merorug - Weaving Your Dream Carpet";
  let title =
    seo.seo_title !== null
      ? seo.seo_title
      : "Valley View School - Children's Haven";
  let image = props.image !== undefined ? props.image : general.logo;
  let description =
    props.description !== undefined
      ? props.description
      : "At Valley View English School, Students in primary and secondary programs undertake a demanding curriculum intended to prepare them for pursing higher studies, which uniquely combines the curriculum in line of the government of Nepal and special learning experiences." +
        "Teachers are always at vigilance to help students during and after their class. The special learning experiences include varieties of activities to be pursued as per the individual choices.";
  let hashtag = props.hashtag !== undefined ? props.hashtag : "#valleyview";

  return (
    <Helmet>
      <title>{title}</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="csrf_token" content="" />
      <meta property="type" content="website" />
      <meta property="url" content={currentUrl} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="_token" content="" />
      <meta name="robots" content="noodp" />
      <meta property="title" content={title} />
      <meta property="quote" content={quote} />
      <meta name="description" content={description} />
      <meta name="keywords" content="Valley View School" />
      <meta property="image" content={image} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:quote" content={quote} />
      <meta property="og:hashtag" content={hashtag} />
      <meta property="og:image" content={image} />
      <meta content="image/*" property="og:image:type" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="Valley View School" />
      <meta property="og:description" content={description} />
      <meta property={db_seo_name} content={db_seo_description} />

      <meta itemprop="name" content={title} />
      <meta itemprop="description" content={description} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default HelmetMetaData;
